<mat-form-field [appearance]="$any(enhancedControl.controlAppearance())">
  <mat-label>{{ label }}</mat-label>
  <mat-chip-grid #chipList>
    @for (item of valueControl.value; track item) {
      <mat-chip-row
        [removable]="removable"
        (removed)="remove(item)"
        [disabled]="disabled"
        >
        {{ item }}
        @if (removable) {
          <button matChipRemove>
            <i class="fas fa-sm fa-times-circle icon"></i>
          </button>
        }
      </mat-chip-row>
    }
    <input #input [placeholder]="label"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="add($event)"
      [disabled]="disabled"
      autocomplete="off">
  </mat-chip-grid>
  <mat-hint align="start">{{hint}}</mat-hint>
  <mat-hint align="end">{{hintRight}}</mat-hint>
</mat-form-field>
